import { render, staticRenderFns } from "./ThePageWrapper.vue?vue&type=template&id=619a3a19&scoped=true&"
import script from "./ThePageWrapper.vue?vue&type=script&lang=js&"
export * from "./ThePageWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ThePageWrapper.vue?vue&type=style&index=0&id=619a3a19&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619a3a19",
  null
  
)

export default component.exports